import { render, staticRenderFns } from "./CollarStatus.vue?vue&type=template&id=02fb3200&"
import script from "./CollarStatus.vue?vue&type=script&lang=js&"
export * from "./CollarStatus.vue?vue&type=script&lang=js&"
import style0 from "./CollarStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports